'use strict'
import {addLoadingContainer, removeLoadingContainer} from '../../scripts/loading';
import {isParsleyForm, isValid} from "../../libs/@elements/parsley-bootstrap-validation";

export function initInScope($scope) {
    const
        $loadingForms = $scope.find('.js-loading-form');

    $loadingForms.each((_,el) => {
        initLoadingForm($(el))
    })
}

function initLoadingForm($form) {
    const $buttons = $form.find('button[type="submit"]');

    function submitForm(e) {
        e.preventDefault();

        $buttons.each((_,el) => {
            removeLoadingContainer($(el))
        })

        if (isParsleyForm($form) && !isValid($form)) {
            e.preventDefault();
            e.stopImmediatePropagation();
            removeLoadingContainer($(e.target))
            return;
        }

        addLoadingContainer($(e.target),[],false);
        $form.submit();
    }

    $buttons.each((_,el) => {
        $(el).on('click', (e) => submitForm(e))
    })
}
